import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import './IconButton.css';
import { IconButtonSize } from './IconButtonSize';
import { twMerge } from 'tailwind-merge';
const SIZE_TO_CLASSES = {
  [IconButtonSize.Small]: 'w-5 h-5 p-1',
  [IconButtonSize.Large]: 'w-9 h-9 p-2'
};

/**
 * A button that is just an icon.
 *
 * @param size
 * @param className
 * @param title
 * @param href
 * @param rawProps Props to pass directly to the button tag.
 * @constructor
 */
export default /*#__PURE__*/forwardRef(function IconButton({
  Icon,
  size = IconButtonSize.Large,
  href,
  className,
  ...rawProps
}, ref) {
  const icon = /*#__PURE__*/React.createElement(Icon, {
    className: "w-full"
  });
  const classes = twMerge(className, SIZE_TO_CLASSES[size], 'flex rounded-full icon-button border border-solid');
  if (href) {
    return /*#__PURE__*/React.createElement("a", _extends({
      ref: ref,
      className: classes
    }, rawProps, {
      href: href
    }), icon);
  }
  return /*#__PURE__*/React.createElement("button", _extends({
    ref: ref,
    className: classes
  }, rawProps), icon);
});